import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, input, Input, ViewEncapsulation } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InputSwitchModule } from 'primeng/inputswitch';
import { CoreControlDirective } from '../../../utils/core-control.directive';

@Component({
  selector: 'osp-input-switch',
  templateUrl: './input-switch.component.html',
  styleUrl: './input-switch.component.scss',
  standalone: true,
  imports: [InputSwitchModule, ReactiveFormsModule, NgClass],
  encapsulation: ViewEncapsulation.None,
  providers: CoreControlDirective.coreControlProvider(InputSwitchComponent),
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputSwitchComponent extends CoreControlDirective {
  @HostBinding('class.osp-input-switch') protected hostCssClassEnabled = true;

  @Input() name?: string;
  @Input() inputId?: string;
  @Input() tabIndex?: number;
  @Input() trueValue: unknown = true;
  @Input() falseValue: unknown = false;
  @Input() readonly = false;
  @Input() autofocus = false;
  @Input() cssClass = '';
  size = input<'small' | 'medium'>('medium');
}
